import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';

const MyPodProductList = React.lazy(() => import('../../modules/DesignTemplateManagement/MyPodProductList'));

export const PodProductConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/podproductlist',
    element: <MyPodProductList key={'podList'} status={'podList'} />,
  },
];
